// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"fef4e37d","222":"f2386860","577":"1bff04aa"}[chunkId] + ".chunk.js";
};